import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useForm } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import provisional from "../../Assets/images/provisional_landing_image.png";
import divider from "../../Assets/images/lpDividerLine.png";
import { useTranslation } from "react-i18next";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";
import { useLocation } from "react-router-dom";
import "../../Assets/css/_psslanding/retailer-pss-landing-page.scss";
import { Notification } from "../../../components/common/Notification";

const AccessCode = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const location = useLocation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isRetailerSpec, setRetailerSpec] = useState(false);
    const [renderComp, setRenderComp] = useState("");
    const [renderStyle, setRederStyle] = useState("");
    const [renderTitle, setRenderTitle] = useState("");
    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);


    const query = new URLSearchParams(props.location.search);
  
    let code: any = query.get("Accesscode");
   
    code = code?.includes(" ") ? code.replace(/\s/g, "+") : code;

    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            accesscode: code ? code : "",
        },
    });


    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [showRetailText, setShowRetailText] = useState(false);
    const [state, setState] = useState({
        accesscode: code ? code : "",
        showErrorMessage: false,
        errorMsg: "AccessCode is Required",
        isLoading: false,
    });



    useEffect(() => {

        if (code != "" && code != null) {
            const data = {
                accesscode: code
            };
            onSubmit(data);        
        }

    }, [code])

    useEffect(() => {
        if (showNotification) {
            Notification({
                type: "error",
                title: "An Error has Occurred",
                message: "Something went wrong, Please try again.",
                duration: 10,
            });
            setShowNotification(false);
        }
    }, [showNotification]);

    useEffect(() => {     
        if (partnerID && RetailerCode) {
            setIsLoading(true);
            const requestBody = {
                PartnerID: partnerID,
                RetailerCode: RetailerCode
            };
            httpClient
                .sendRequest("POST", "api/PssLandingPage/GetRetailerPSSSerData", requestBody)
                .then((data) => {
                    if (data?.key! == null || !data["HasError"]) {
                        setRetailerSpec(true);
                        setRederStyle(data.retailerPSSStyle);
                        setRenderComp(data.retailerPSSHTML);
                        setRenderTitle(data.retailerPSSTitle)

                        setIsLoading(false);
                    }
                })
                .catch(function (error) {
                    setIsLoading(true);
                    setShowNotification(true);
                });
        }

    }, [partnerID]);

    const handleInputChange = (event: any) => {
    
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmit = (data: any) => {

    
        setShowAccessCodeField(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            provisionalID: data.accesscode,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage1?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    if (RetailerCode != null && RetailerCode != "") {
                        props.history.push({
                            pathname:
                                "/Register?Type=" +
                                data.provisionalResponseLanding[0].contractStatus +
                                "&VALUE=" +
                                data.provisionalResponseLanding[0].provisionalID +
                                "&RETAILERCODE=" +
                                RetailerCode +
                                "&GNDNRLL=PSS",
                        });

                    } else {
                        props.history.push({
                            pathname:
                                "/Register?Type=" +
                                data.provisionalResponseLanding[0].contractStatus +
                                "&VALUE=" +
                                data.provisionalResponseLanding[0].provisionalID +
                                "&GNDNRLL=PSS",
                        });
                    }                 
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, accesscode: "" });
            });
    };
    const handleClick = () => {
        handleSubmit(onSubmit);
        window.addToDataLayer({ event: "PSS1 Continue" });
    }
    if (isLoading) {
        return (
            <div className="col-xs">
                <div className={`loading`}></div>
            </div>
        );
    } else {
        return (
            <React.Fragment>
                {!isRetailerSpec ?
                    <>
                        {showAccessCodeField == true && <PSSBannerMessage layout={"psslandingaccesscode"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />}
                        <main is="x3d" id="l-page-content main-content">
                            <div className="row l-page-container">
                                <div style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            backgroundImage: `url(${provisional})`,
                                        }}
                                        id="main-left-bg"
                                    ></div>
                                    <div className="pss-right-content">
                                        <h2>Your Identity Protection Begins Today!</h2>
                                        <div className="receipt-code-copy">
                                            Simply enter the access code provided to
                                            <br />
                                            you by a Resolution Specialist.
                                        </div>
                                        <form id="form-member-login" onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-row">
                                                <div className="form-label">
                                                    <label className="access-code-label" htmlFor="accesscode">
                                                        Access Code
                                                    </label>
                                                </div>
                                                <div className="pss1-accessCode">
                                                    <div className="form-input">
                                                        <input
                                                            aria-required="true"
                                                            className="access-code-input-pin"
                                                            type="text"
                                                            id="accesscode"
                                                            name="accesscode"
                                                            onChange={handleInputChange}
                                                            ref={register({
                                                                required: true,
                                                                maxLength: 12,
                                                            })}
                                                        />
                                                        {errors.accesscode && errors.accesscode.type === "required" && (
                                                            <div className="form-row" style={{ marginBottom: "0em" }}>
                                                                <div role="alert" aria-live="assertive" className="col-xs-12 col-no-gutter">
                                                                    <span className="error-msg">Access Code is required</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {errors.accesscode && errors.accesscode.type === "maxLength" && (
                                                            <div className="form-row" style={{ marginBottom: "0em" }}>
                                                                <div role="alert" aria-live="assertive" className="col-xs-12 col-no-gutter">
                                                                    <span className="error-msg">Invalid Access Code</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <input type="submit" onClick={() => handleSubmit(onSubmit)} value="Get Started" className="mobile-button" />
                                                </div>
                                                <a href="/app/login" className="pss-login-link">
                                                    Click here to Log In
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/*<div className="divider-img">*/}
                                {/*    <img src={divider} alt="" />*/}
                                {/*</div>*/}
                            </div>
                        </main>

                    </> :
                    <>
                        {showAccessCodeField == true && <PSSBannerMessage layout={"retailerpsslandingaccesscode"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />}
                        <style dangerouslySetInnerHTML={{ __html: renderStyle }}></style>
                        <div id="retailer-pss-landing" className="enrollmentStart relative">
                            <div id="pss-container-content" className="pssContainerContent">
                                <div className="retailer-pss-page-TMPL9" dangerouslySetInnerHTML={{ __html: renderComp }}></div>
                            </div>
                            <div id="enrollmentStepView" className="enrollmentSteps">
                                <div id="pssContentTitle" className="retailer-pss-page-TMPL9" dangerouslySetInnerHTML={{ __html: renderTitle }}></div>
                                <div className="retailer-pss-page-TMPL9" id="divPSS1Enrollement">
                                    <form id="form-member-login-retailer" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="receiptCodeCopy">
                                            Simply enter the access code provided to you by<br /> a Resolution Specialist.
                                        </div>
                                        <div className="lpEnrollmentField fl">
                                            <label className="lpEnrollmentField fl" htmlFor="accesscode">Access Code
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                aria-required="true"
                                                id="accesscode"
                                                name="accesscode"
                                                className="field ep_half_field"
                                                onChange={handleInputChange}
                                                ref={register({
                                                    required: true,
                                                    maxLength: 12,
                                                })} />
                                            {errors.accesscode && errors.accesscode.type === "required" && (
                                                <div className="form-row" style={{ marginBottom: "0em" }}>
                                                    <div role="alert" aria-live="assertive" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg">Access Code is required</span>
                                                    </div>
                                                </div>
                                            )}
                                            {errors.accesscode && errors.accesscode.type === "maxLength" && (
                                                <div className="form-row" style={{ marginBottom: "0em" }}>
                                                    <div role="alert" aria-live="assertive" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg">Invalid Access Code</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <input type="submit" onClick={() => handleClick()} value="Continue" className="mobileButton receiptCodeButton" />
                                    </form>
                                </div>


                            </div>
                        </div>
                    </>
                }
            </React.Fragment>
        );
    }
};
export default AccessCode;
